import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const Home = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTalithaModalOpen, setIsTalithaModalOpen] = useState(false);
  const [isOutreachModalOpen, setIsOutreachModalOpen] = useState(false);
  const [isAuthorModalOpen, setIsAuthorModalOpen] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate form submission
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 3000);
    setEmail('');
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openTalithaModal = () => {
    setIsTalithaModalOpen(true);
  };

  const closeTalithaModal = () => {
    setIsTalithaModalOpen(false);
  };

  const openOutreachModal = () => {
    setIsOutreachModalOpen(true);
  };

  const closeOutreachModal = () => {
    setIsOutreachModalOpen(false);
  };

  const openAuthorModal = () => {
    setIsAuthorModalOpen(true);
  };

  const closeAuthorModal = () => {
    setIsAuthorModalOpen(false);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/93364f2999c467a302d08ace296f775a.jpg')`
        }}
      >
        <div className="w-full px-6 py-20">
          <div className="max-w-6xl mx-auto">
            <div className="max-w-2xl">
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
                RACISM EQUALS: WEALTH AND POWER
              </h1>
              <p className="text-xl md:text-2xl text-gray-200 mb-4 font-medium">
                THE REVELATION KNOWLEDGE FROM THE "WORD OF GOD"
              </p>
              <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                Discover profound truths about racism, wealth, and power through divine revelation. 
                Join thousands of readers on a journey of spiritual enlightenment and understanding.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="https://www.amazon.com/s?k=RACISM+EQUALS+WEALTH+AND+POWER+James+Smith&ref=nb_sb_noss"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 text-lg font-semibold whitespace-nowrap cursor-pointer w-full sm:w-auto rounded-lg text-center transition-colors inline-block"
                >
                  Get the Book
                </a>
                <Button 
                  variant="secondary"
                  onClick={openAuthorModal}
                  className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 text-lg font-semibold whitespace-nowrap cursor-pointer w-full sm:w-auto rounded-lg text-center transition-colors"
                >
                  Meet the Author
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Divine Revelation for Modern Times
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Through careful study of God's Word, this groundbreaking book reveals how racism has been systematically used as a tool to concentrate wealth and power, keeping communities divided while the truth remains hidden.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                Pastor James A. Smith provides biblical insight that exposes these deceptions and offers hope for true healing and unity according to God's divine plan.
              </p>
              <div className="flex items-center gap-4">
                <Button 
                  variant="primary"
                  className="bg-amber-600 hover:bg-amber-700 text-white px-6 py-3 font-semibold whitespace-nowrap cursor-pointer"
                >
                  Read Sample Chapter
                </Button>
                <Link to="/about" className="text-amber-600 font-semibold hover:text-amber-700 cursor-pointer">
                  About the Author →
                </Link>
              </div>
            </div>
            <div className="lg:pl-8">
              <img
                src="https://static.readdy.ai/image/301b91c9adaca0684fe24f931e418917/40230e5bf978fd0b50237fa87895eef2.jfif"
                alt="RACISM EQUALS: WEALTH AND POWER book cover"
                className="w-full max-w-md mx-auto rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Why This Book Matters
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover biblical truths that provide clarity, hope, and actionable solutions for addressing racial inequality in our time.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div 
              className="text-center p-8 rounded-xl bg-amber-50 border border-amber-100 cursor-pointer hover:bg-amber-100 transition-colors"
              onClick={openModal}
            >
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-eye-line text-2xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">The Pastor's Vision</h3>
              <p className="text-gray-600">
                Uncover how racism has been systematically weaponized to maintain wealth concentration and power structures that divide communities.
              </p>
              <div className="mt-6">
                <img
                  src="https://static.readdy.ai/image/301b91c9adaca0684fe24f931e418917/f5fb04fd145f0f55e88fd24103758484.png"
                  alt="The Pastor's Vision - Ministry Document"
                  className="w-full max-sm-w-sm mx-auto rounded-lg shadow-lg"
                />
              </div>
              <p className="text-amber-600 font-medium mt-4 text-sm">Click to view full document</p>
            </div>
            
            <div 
              className="text-center p-8 rounded-xl bg-amber-50 border border-amber-100 cursor-pointer hover:bg-amber-100 transition-colors"
              onClick={openTalithaModal}
            >
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-2xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">TALITHA CUMI</h3>
              <p className="text-gray-600">
                Discover the powerful ministry mission dedicated to reaching women of all ages, ethnicities, and economic status through the Gospel of Jesus Christ.
              </p>
              <div className="mt-6">
                <img
                  src="https://static.readdy.ai/image/301b91c9adaca0684fe24f931e418917/04e68ff120ff011ac3bb60ca66d82b2a.png"
                  alt="Talitha Cumi Women's Ministry Mission Statement"
                  className="w-full max-sm-w-sm mx-auto rounded-lg shadow-lg"
                />
              </div>
              <p className="text-amber-600 font-medium mt-4 text-sm">Click to view full document</p>
            </div>
            
            <div 
              className="text-center p-8 rounded-xl bg-amber-50 border border-amber-100 cursor-pointer hover:bg-amber-100 transition-colors"
              onClick={openOutreachModal}
            >
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-heart-line text-2xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">OUTREACH</h3>
              <p className="text-gray-600">
                Explore the ministry's outreach initiatives and community engagement programs designed to spread God's love and biblical truth to all people.
              </p>
              <div className="mt-6">
                <img
                  src="https://static.readdy.ai/image/301b91c9adaca0684fe24f931e418917/7c506e684ffbcb9995ec14da272f4c3a.png"
                  alt="Redeeming Power Ministry Outreach Document"
                  className="w-full max-sm-w-sm mx-auto rounded-lg shadow-lg"
                />
              </div>
              <p className="text-amber-600 font-medium mt-4 text-sm">Click to view full document</p>
            </div>
          </div>
        </div>
      </section>

      {/* Modal for Pastor's Vision Document */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-auto relative">
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full cursor-pointer z-10"
            >
              <i className="ri-close-line text-xl text-gray-600"></i>
            </button>
            <div className="p-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 pr-12">The Pastor's Vision - Ministry Document</h3>
              <img
                src="https://static.readdy.ai/image/301b91c9adaca0684fe24f931e418917/f5fb04fd145f0f55e88fd24103758484.png"
                alt="The Pastor's Vision - Full Ministry Document"
                className="w-full rounded-lg shadow-lg"
              />
              <div className="mt-6 text-gray-600">
                <p className="mb-4">
                  This official ministry document outlines Pastor James A. Smith's divine vision for the Redeeming Power Ministry and his calling to reveal biblical truths about racism, wealth, and power.
                </p>
                <p>
                  Through this ministry, Pastor Smith seeks to bring healing, understanding, and unity to communities by exposing the spiritual forces behind racial division and providing God's blueprint for true justice and reconciliation.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Talitha Cumi Document */}
      {isTalithaModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-auto relative">
            <button
              onClick={closeTalithaModal}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full cursor-pointer z-10"
            >
              <i className="ri-close-line text-xl text-gray-600"></i>
            </button>
            <div className="p-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 pr-12">TALITHA CUMI Women's Ministry Mission Statement</h3>
              <img
                src="https://static.readdy.ai/image/301b91c9adaca0684fe24f931e418917/04e68ff120ff011ac3bb60ca66d82b2a.png"
                alt="Talitha Cumi Women's Ministry Mission Statement - Full Document"
                className="w-full rounded-lg shadow-lg"
              />
              <div className="mt-6 text-gray-600">
                <p className="mb-4">
                  The "Talitha Cumi Women's Ministry" mission statement outlines Pastor James A. Smith's vision to reach women of all ages, ethnicities, and economic status by sharing the Gospel of Jesus Christ with the world.
                </p>
                <p className="mb-4">
                  The ministry focuses on sharing the message of Jesus' desire to resurrect every dead situation in our lives and to call us out of the things that have us bound, just as Jesus called the damsel out of death over 2000 years ago.
                </p>
                <p>
                  Through Bible studies, prayer, love, and fellowship, "Talitha Cumi Women's Ministry" spreads the news that the love and saving "Power of Jesus Christ" is alive and well and continues to bring new life to those who seek spiritual healing and transformation.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Outreach Document */}
      {isOutreachModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-auto relative">
            <button
              onClick={closeOutreachModal}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full cursor-pointer z-10"
            >
              <i className="ri-close-line text-xl text-gray-600"></i>
            </button>
            <div className="p-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 pr-12">Redeeming Power Ministry - Outreach Document</h3>
              <img
                src="https://static.readdy.ai/image/301b91c9adaca0684fe24f931e418917/7c506e684ffbcb9995ec14da272f4c3a.png"
                alt="Redeeming Power Ministry Outreach Document - Full Document"
                className="w-full rounded-lg shadow-lg"
              />
              <div className="mt-6 text-gray-600">
                <p className="mb-4">
                  This official outreach document from Redeeming Power Ministry outlines the ministry's commitment to spreading God's love and biblical truth throughout the community and beyond.
                </p>
                <p className="mb-4">
                  The ministry's outreach efforts focus on bringing the Gospel message to all people, regardless of their background, and providing spiritual guidance based on the Word of God.
                </p>
                <p>
                  Through various community programs, Bible studies, and fellowship opportunities, Redeeming Power Ministry seeks to be a beacon of hope and truth, helping individuals discover God's plan for their lives and His perspective on important social issues.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for About the Author */}
      {isAuthorModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-auto relative">
            <button
              onClick={closeAuthorModal}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full cursor-pointer z-10"
            >
              <i className="ri-close-line text-xl text-gray-600"></i>
            </button>
            <div className="p-6">
              <img
                src="https://static.readdy.ai/image/301b91c9adaca0684fe24f931e418917/d99a90bdc0f30490164b0534d7765ade.jpeg"
                alt="About the Book and Author - Full Document"
                className="w-full rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      )}

      {/* Blog Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Latest Insights
            </h2>
            <p className="text-xl text-gray-600">
              Watch Pastor James A. Smith share powerful biblical revelations
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto flex flex-col gap-10">
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full rounded-xl shadow-2xl"
                src="https://www.youtube.com/embed/g8-CDohVy4s"
                title="Pastor James A. Smith - Biblical Revelations"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full rounded-xl shadow-2xl"
                src="https://www.youtube.com/embed/jn3Iy6Q7p3A"
                title="Pastor James A. Smith - Biblical Revelations Part 2"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-amber-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            Join Our Community of Truth Seekers
          </h2>
          <p className="text-xl text-amber-100 mb-8">
            Get exclusive insights, updates on events, and biblical revelations delivered to your inbox.
          </p>
          
          {isSubmitted ? (
            <div className="bg-white/10 border border-white/20 rounded-lg p-6 max-w-md mx-auto">
              <i className="ri-check-line text-3xl text-white mb-2"></i>
              <p className="text-white font-medium">Thank you for subscribing!</p>
            </div>
          ) : (
            <form onSubmit={handleNewsletterSubmit} className="max-w-md mx-auto">
              <div className="flex gap-4">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                  className="flex-1 px-4 py-3 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white"
                />
                <Button 
                  type="submit"
                  variant="secondary"
                  className="bg-white text-amber-600 hover:bg-gray-100 px-6 py-3 font-semibold whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                </Button>
              </div>
            </form>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Discover God's Truth?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Don't wait to uncover the biblical revelations that can transform your understanding of race, justice, and God's plan for unity.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a 
              href="https://www.amazon.com/s?k=RACISM+EQUALS+WEALTH+AND+POWER+James+Smith&ref=nb_sb_noss"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 text-lg font-semibold whitespace-nowrap cursor-pointer rounded-lg text-center transition-colors inline-block"
            >
              Order Your Copy Today
            </a>
            <Button 
              variant="secondary"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 text-lg font-semibold whitespace-nowrap cursor-pointer"
            >
              Contact Pastor Smith
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
